import type { IntlShape } from "react-intl";
import type { Image } from "~types/image";

const getImageQualityWarnings = (image: Image, formatMessage: IntlShape["formatMessage"]) => {
  const warnings: string[] = [];

  if (image.rating === "LOW") {
    warnings.push(formatMessage({ id: "image.quality.warning" }));
  }

  if (image.maximumHeight * image.maximumWidth < 10e5) {
    warnings.push(formatMessage({ id: "image.size.warning" }));
  }

  return warnings;
};

export default getImageQualityWarnings;
